import {
  BoxBufferGeometry,
  MeshBasicMaterial,
  Mesh,
  Color,
  ShaderMaterial,
  AdditiveBlending,
} from "three";

const newVersion  = true;
import { Text as TextMap } from "./text.old";
import { Text as TextMaterial} from "./text.new";

const cache = {};

class Brick {

  constructor( size = 64, color = 0xFF0000, copy = null, type = 1 ) { // no longer based on UK house brick (215 x 102.5 x 65mm) but instead a 2:1 rectangle to make everything simple!!

    // type = randomInt(1,3);

    if( !cache[size] ) cache[size] = {} // so we can cache similar size geos
    if( !cache[type] ) cache[type] = {} // so we can cache similar bitmap materials

    /* SETUP */
    const useBitmap = ( window.CONFIG && window.CONFIG.materials ) ? window.CONFIG.materials.bitmap :  false;
    const useWireframe = ( window.CONFIG && window.CONFIG.materials ) ? window.CONFIG.materials.wireframe :  false;

    /* GEO */
    const geometry = cache[size].geometry || new BoxBufferGeometry( size*2, size, size, 1, 1, 1 );
    if( !cache[size].geometry ) cache[size].geometry = geometry;

    /* MATERIAL */
    let materials;
    if( !cache[type].materials && window.ASSETS && useBitmap ){
      materials = [
        window.ASSETS.textures.find(obj => { return obj.name === 'brickside'+type }).material,
        window.ASSETS.textures.find(obj => { return obj.name === 'brickside'+type }).material,
        window.ASSETS.textures.find(obj => { return obj.name === 'bricktop'+type }).material, // THE TOP SIDE
        window.ASSETS.textures.find(obj => { return obj.name === 'brickside'+type }).material,
        window.ASSETS.textures.find(obj => { return obj.name === 'brickside'+type }).material,
        window.ASSETS.textures.find(obj => { return obj.name === 'brickside'+type }).material,
      ];
      cache[type].materials = materials;
    }else if( !cache[type].materials ){
      materials = [
        new MeshBasicMaterial({color:color, needsUpdate : false}),
        new MeshBasicMaterial({color:color, needsUpdate : false}),
        new MeshBasicMaterial({color:color, needsUpdate : false}), // THE TOP SIDE
        new MeshBasicMaterial({color:color, needsUpdate : false}),
        new MeshBasicMaterial({color:color, needsUpdate : false}),
        new MeshBasicMaterial({color:color, needsUpdate : false}),
      ];
      cache[type].materials = materials;
    }else{
      materials = [
        cache[type].materials[0],
        cache[type].materials[1],
        cache[type].materials[2].clone(),// THE TOP SIDE
        cache[type].materials[3],
        cache[type].materials[4],
        cache[type].materials[5],
      ]
    }

    /* MATERIALS UPDATES */
    // if( copy ){
    //   if(!newVersion) materials[2].map = new TextMap( copy, size, type );
    //   if(newVersion) materials[2] = new TextMaterial( copy, size, type );
    //   // materials[2].minFilter = LinearFilter;
    //   // materials[2].generateMipmaps = false;
    //   // materials[2].needsUpdate = false;
    // }

    if( useWireframe ){
      for (let i = 0; i < materials.length; i++) {
        materials[i].wireframe = useWireframe;
      }
    }

    /* MESH */
    const mesh = new Mesh(geometry, materials);
    mesh.matrixAutoUpdate = true;
    //mesh.layers.enable( 1 ); // TODO: can use layers with raycaster to improve performance

    if( !cache.glow ){

      /* -----------------
        TEMP GLOW CODE
        TODO: need to move this to it's own file !!!    
        idea from view-source:http://stemkoski.github.io/Three.js/Shader-Halo.html
      */

      // create custom material from the shader code above
      // that is within specially labeled script tags

      const vShader = `
        varying vec2 v_uv;
        void main() {
          v_uv = uv;
          gl_Position = projectionMatrix * modelViewMatrix *    vec4(position, 1.0);
        }`;

      const fShader = `
        varying vec2 v_uv;
        uniform vec2 u_mouse;
        uniform vec2 u_resolution;
        uniform vec3 u_color;
        uniform float u_time;
        void main() {
          vec2 v = u_mouse / u_resolution;
          vec2 uv = gl_FragCoord.xy / u_resolution;
          gl_FragColor = vec4(1.0, 1.0, 1.0, 0.25).rgba;
        }`;

      const glowMaterial = new ShaderMaterial({
        uniforms: { },
        // vertexShader:   document.getElementById('vertexShader').textContent,
        // fragmentShader: document.getElementById('fragmentShader').textContent,
        vertexShader: vShader,
        fragmentShader: fShader,
        // side: DoubleSide,
        // // side: BackSide,
        blending: AdditiveBlending, 
        // depthTest: false,
        transparent: true
      });

      const glowBrick = new BoxBufferGeometry( (size*2)+1, size+1, size+1, 1, 1, 1 );
      const glowMesh = new Mesh( glowBrick, glowMaterial );
      glowMesh.matrixAutoUpdate = false;
      cache.glow = glowMesh;
    }
    /* ------------ */

    /* FUNCTIONS */

    

    mesh.addText = ()=>{ /* WE DO THIS ON LAZY LOAD NOW TO IMPROVE PERFORMANCE! */

      if( copy ){
        if(!newVersion) materials[2].map = new TextMap( copy, size, type );
        if(newVersion) materials[2] = new TextMaterial( copy, size, type );
        // materials[2].minFilter = LinearFilter;
        // materials[2].generateMipmaps = false;
        // materials[2].needsUpdate = false;
      }

    }

    mesh.updateColor = ( c )=>{
      c = new Color(c);
      color.convertSRGBToLinear();
      for (let i = 0; i < mesh.material.length; i++) {
        if(i == 2) mesh.material[i].color.set( c ); // just top for now
      }
    }

    let selected = false;
    let over = false;

    mesh.onOver = ()=>{
      if( selected ) return null;
      over = true;
      mesh.translateY( size/4 );
      // mesh.updateColor( 0xff0ff020 );
    }

    mesh.onOut = ()=>{
      if( selected ) return null;
      over = false;
      mesh.translateY( -size/4 );
      // const c = ( useBitmap ) ? 0xffffff : color;
      // mesh.updateColor( c );
    }
    
    mesh.onSelect = ()=>{
      if( over ) mesh.onOut(); // as we disabled the mouse roll out we need to move the brick back before moving again on desktop only
      selected = true;
      mesh.translateY( size/2 );
      // mesh.updateColor( 0x0563d1 ); // 0563d1cc
      // mesh.updateColor( 0xff0ff020 );
      mesh.add( cache.glow )
    }

    mesh.onDeselect = ()=>{
      mesh.translateY( -size/2 );
      // const c = ( useBitmap ) ? 0xffffff : color;
      // mesh.updateColor( c );
      mesh.remove( cache.glow );
      selected = false;
    }

    return mesh;
  }

}

export { Brick };